
import * as firebase from "firebase/app";
import "firebase/firestore";
import Logo from "../../login/Logo.vue";
import {ValidationRules} from "@/utils/validation-rules";

import {Component, Vue} from "vue-property-decorator";
import {getRegionName} from "@/utils/functionsRegion";

@Component({
  components: {
    Logo
  }
})
export default class ResetFamilyHubUserPassword extends Vue {
  email = "";
  password = "";
  repeatPassword = "";
  isVisiblePassword = false;
  isVisibleRepeatPassword = false;
  isFormValid = true;
  isLoading = false;
  isError = false;
  isPasswordSet = false;
  user = {id: null, orgLogoUrl: null} as any;
  screenWidth = window.innerWidth;

  get rules() {
    return {
      password: [
        ValidationRules.required,
        ValidationRules.min(6),
        ValidationRules.number,
        ValidationRules.capitalLetter,
        ValidationRules.lowerLetter,
        ValidationRules.symbol
      ],
      repeatPassword: [
        ValidationRules.required,
        ValidationRules.min(6),
        ValidationRules.isEqualTo(this.password)
      ]
    };
  }

  get actionCode(): string {
    return this.$route.query.oobCode as string;
  }

  get screenWidthClass() {
    return this.screenWidth > 600 ? 'w-75' : '';
  }

  get screenJustifyClass() {
    return this.screenWidth > 600 ? 'justify-content-center' : '';
  }

  async created() {
    await firebase.app().functions(getRegionName()).httpsCallable('familyUser-getByToken')({
      resetPasswordToken: this.$route.params.token,
    })
    .then((result) => {
      if (result?.data?.status === 200) {
        this.user.id = result.data.data.id
        this.user.orgLogoUrl = result.data.data.orgLogoUrl
      } else{
        this.isError = true;
        this.$toast.open({
          message: result?.data?.message || "Unable to set password",
          type: "error"
        });
      }
    })
  }

  async onSubmit() {
    // eslint-disable-next-line
    this.isFormValid = (this.$refs.form as any).validate();

    if (!this.isFormValid) return;

    this.isLoading = true;

    try {
      await firebase.app().functions(getRegionName()).httpsCallable('familyUser-updateFamilyUserPassword')({
        familyHubUserId: this.user.id,
        newPassword: this.password
      }).then(() => {
        this.isPasswordSet = true;
        firebase
            .firestore()
            .collection('familyHubUsers')
            .doc(this.user.id)
            .update({resetPasswordToken: null, passwordResetDateTime: firebase.firestore.Timestamp.now()}).then(() => {
          this.$toast.open({
            message: "Password successfully changed",
            type: "success"
          });

          this.isLoading = false;
        })
      }).catch(() => {
        this.$toast.open({
          message: "Unable to set new password",
          type: "error"
        });
        this.isLoading = false;
      })


    } catch (e) {
      console.error(e);
    }

  }

}
